import { FC } from 'react'

import { ModalProps } from 'antd'

import { StyledModal } from './styles'

export type Props = ModalProps & {
  showTopbar?: boolean
  showCloseButton?: boolean
  fixedCloseButton?: boolean
}

export const FullScreenModal: FC<Props> = (props) => {
  const {
    children,
    showCloseButton,
    showTopbar,
    fixedCloseButton = true,
    ...restProps
  } = props
  return (
    <StyledModal
      $showTopbar={showTopbar}
      $showCloseButton={showCloseButton}
      $fixedCloseButton={fixedCloseButton}
      {...restProps}
    >
      {children}
    </StyledModal>
  )
}
